import React from 'react'
import { constants } from 'common/helpers'
import Text from 'components/_new/typography/Text/Text'

import composeDialogModal from 'components/modals/DialogModal/composeDialogModal'

import messages from './messages'


const ErrorCardModal = composeDialogModal({
  name: constants.modals.ErrorCard,
  title: messages.title,
  buttonTitle: messages.button,
  content: (
    <Text message={messages.text} size="16-20" />
  ),
})


export default ErrorCardModal
